import { Collection } from '@signaldb/core'
import createIndexedDBAdapter from '@signaldb/indexeddb'
import maverickjsReactivityAdapter from './reactivity'
window.Collection = Collection

// export const ingredients = new Collection({ persistence: createIndexedDBAdapter('ingredients') })
// export const processing = new Collection({persistence: createIndexedDBAdapter('processing')})
// export const characterizations = new Collection({persistence: createIndexedDBAdapter('characterizations')})
// export const properties = new Collection({persistence: createIndexedDBAdapter('properties')})
// export const stages = new Collection({persistence: createIndexedDBAdapter('stages')})
// export const material = new Collection({persistence: createIndexedDBAdapter('material')})
// export const application = new Collection({persistence: createIndexedDBAdapter('application')})
// export const order_type = new Collection({persistence: createIndexedDBAdapter('order_type')})
// export const grade = new Collection({persistence: createIndexedDBAdapter('grade')})
// export const descriptor = new Collection({persistence: createIndexedDBAdapter('descriptor')})
// export const project_tags = new Collection({persistence: createIndexedDBAdapter('project_tags')})
// export const timestamp = new Collection({persistence: createIndexedDBAdapter('timestamp')})
// export const language = new Collection({persistence: createIndexedDBAdapter('language')})
// export const metadata_propertie = new Collection({persistence: createIndexedDBAdapter('metadata_propertie')})

export const Samples = new Collection({
    persistence: createIndexedDBAdapter('Samples'),
    reactivity: maverickjsReactivityAdapter
})
window.Samples = Samples


